import {BASE_URL} from "../../config/network";

const postalCodeLookupAPI = async ({zipCode, houseNumber}) => {
    const normalizedZipCode = String(zipCode || "").replace(/\s+/g, "").toUpperCase();
    const normalizedHouseNumber = String(houseNumber || "").trim();

    const URL = `${BASE_URL}/public/postal-codes/${encodeURIComponent(normalizedZipCode)}/${encodeURIComponent(normalizedHouseNumber)}`;
    const METHOD = "GET";
    const HEADERS = {
        Accept: "application/json",
        "Content-Type": "application/json",
    };

    const response = await fetch(URL, {
        method: METHOD,
        headers: HEADERS,
    });

    if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
    }

    return await response.json();
};

export {postalCodeLookupAPI};
